module.exports = __webpack_public_path__ + "static/media/modis2941.fbb4d17b.jpg";